"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "Add a custom color": "Aggiungi un colore personalizzato",
  Apply: "Applica",
  "Apply color": "Applica colore",
  Automatic: "Automatico",
  Cancel: "Annulla",
  "Cancel color": "Elimina colore",
  Change: "Modifica",
  Custom: "Personalizzato",
  "Custom color picker": "Selettore colori personalizzati",
  "Invalid hex value": "Valore esadecimale non valido",
  Remove: "Elimina",
  "Select color {color}": ["Seleziona colore ", ["color"]],
  "You’ve reached the {maxCustomColors} custom colors limit. To add another color, remove one first.": ["Hai raggiunto il limite di ", ["maxCustomColors"], " colori personalizzati. Per aggiungere un altro colore, prima rimuovine uno."]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map